import { useEffect, useMemo, useState } from 'react';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { LANGUAGES } from 'constants/index.js';
import { useAppContext } from 'services/context';
import { useSessionStorage } from 'services/hooks';
import { LANGAUGE_ACTIONS, USER_ACTIONS } from 'services/reducers/actionTypes';
import './style.css';

const LanguageSelector = () => {
	const SWIPE_THRESHOLD = 50;
	let touchStart = 0;

	const { Api, user, dispatchUser, lang, setLang } = useAppContext();
	const [_, setCacheUser] = useSessionStorage('user', '');
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (user && user?.token) setLang({ type: LANGAUGE_ACTIONS.CHANGE_LANG, languageId: user?.preferredLanguageId });
	}, []);

	const currentLang = useMemo(() => {
		return LANGUAGES.find(language => language.translation_id === lang);
	}, [lang]);

	const languagesOptions = useMemo(() => {
		const english = LANGUAGES.find(language => language.iso === 'EN');
		const spanish = LANGUAGES.find(language => language.iso === 'ES');
		const french = LANGUAGES.find(language => language.iso === 'FR');

		return [
			{
				description: english?.nativeDescription,
				value: english?.translation_id,
			},
			{
				description: spanish?.nativeDescription,
				value: spanish?.translation_id,
			},
			{
				description: french?.nativeDescription,
				value: french?.translation_id,
			},
		];
	}, [lang]);

	const toggleMenu = () => {
		setOpen(prev => !prev);
	};

	const _handleChangeLang = async langId => {
		try {
			setLang({ type: LANGAUGE_ACTIONS.CHANGE_LANG, languageId: langId });
			toggleMenu();

			if (!user || !user.userId) return;

			//Save the new preferred language.
			dispatchUser({ type: USER_ACTIONS.UPDATE_PREFERRED_LANGUAGE_ID, payload: { ...user, preferredLanguageId: langId } });
			setCacheUser({ ...user, preferredLanguageId: langId });

			const res = await Api.UpdateUserPreferredLanguage({ userId: user.userId, preferredLanguageId: langId });
			if (!res) console.error(`Updating the user's preferred language failed.`);
		} catch (ex) {
			console.error('_handleChangeLang', ex);
		}
	};

	const _handleTouchStart = e => (touchStart = e?.touches[0]?.screenX);

	const _handleTouchEnd = e => {
		try {
			let touchEnd = e?.changedTouches[0]?.screenX;
			const deltaX = Math.abs(touchStart - touchEnd);
			if (touchStart < touchEnd && deltaX > SWIPE_THRESHOLD) setOpen(false); //only on swipe right more than 50 pixels
			touchStart = 0;
		} catch (err) {}
	};

	return (
		<div className="language_selector">
			<Button
				title={currentLang?.nativeDescription}
				startIcon="globalIcon"
				iconSize={23}
				iconColor="white"
				skew
				extraClassName="language_selector__button"
				onClick={toggleMenu}
			/>
			<Icon icon="globalIcon" extraClassName="language_selector__icon" color="black" iconSize={100} onClick={toggleMenu} />
			<ul className={`language_selector__options ${open ? 'open' : 'close'}`} onTouchStart={_handleTouchStart} onTouchEnd={_handleTouchEnd}>
				{languagesOptions?.map(({ description, value }) => (
					<li className={`${value === lang ? 'selected' : ''}`} id={value} key={value} onClick={() => _handleChangeLang(value)}>
						{description}
					</li>
				))}
			</ul>
		</div>
	);
};

export default LanguageSelector;
